import { render } from "./adminpanel.vue?vue&type=template&id=7a9be2ac&scoped=true"
import script from "./adminpanel.vue?vue&type=script&lang=js"
export * from "./adminpanel.vue?vue&type=script&lang=js"

import "./adminpanel.vue?vue&type=style&index=0&id=7a9be2ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9be2ac"]])

export default __exports__